module.exports = __webpack_public_path__ + "img/bank-upload-file.e48f422a.svg";